import { addMinutes, differenceInMinutes, format, isSameDay } from 'date-fns'

export const RESULTS = [
  { value: 'CONNECTED', label: 'Connected' },
  { value: 'NO_ANSWER', label: 'No answer' },
  { value: 'BUSY', label: 'Busy' },
  { value: 'VOICEMAIL', label: 'Left voicemail' },
  { value: 'WRONG_NUMBER', label: 'Wrong number' },
]
export const RESULT_LABEL = Object.fromEntries(RESULTS.map((r) => [r.value, r.label]))

export const DURATIONS = [5, 10, 15, 30, 45, 60, 90, 120]
export const durationLabel = (m) => (m < 60 ? `${m} min` : m % 60 === 0 ? `${m / 60} h` : `${Math.floor(m / 60)} h ${m % 60} min`)

export const MEETING_REMINDERS = [
  { value: '', label: 'No reminder' },
  { value: 10, label: '10 minutes before' },
  { value: 30, label: '30 minutes before' },
  { value: 60, label: '1 hour before' },
  { value: 1440, label: '1 day before' },
]

export const STATUS_LABEL = { PLANNED: 'Planned', DONE: 'Held', CANCELLED: 'Cancelled' }

/** Next half hour from now (a new meeting) or 15 minutes ago (a call just made), as an input value. */
export const defaultStart = (kind) => {
  const d = new Date()
  if (kind === 'CALL') return format(addMinutes(d, -10), "yyyy-MM-dd'T'HH:mm")
  d.setMinutes(d.getMinutes() < 30 ? 30 : 60, 0, 0)
  return format(d, "yyyy-MM-dd'T'HH:mm")
}

export const minutesBetween = (start, end) => Math.max(0, differenceInMinutes(new Date(end), new Date(start)))
export const plusMinutes = (inputValue, minutes) => format(addMinutes(new Date(inputValue), minutes), "yyyy-MM-dd'T'HH:mm")

/** "Mon 19 Oct, 10:30 – 11:30" (same day) or with both dates. */
export const whenLabel = (startsAt, endsAt) => {
  const s = new Date(startsAt)
  const e = new Date(endsAt)
  const day = format(s, s.getFullYear() === new Date().getFullYear() ? 'EEE d MMM' : 'EEE d MMM yyyy')
  if (isSameDay(s, e)) return `${day}, ${format(s, 'HH:mm')} – ${format(e, 'HH:mm')}`
  return `${day}, ${format(s, 'HH:mm')} – ${format(e, 'd MMM HH:mm')}`
}

export const isEmail = (v) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v.trim())
